// Auto-generated cornerstone translation for de.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:32:41.524914+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Pferdeverwal­tungs-App: beste Wahl für 2026 | EquiSight",
      description: "Vergleiche Pferderverwaltungs-Apps für Besitzer, Stall und Zucht. Entdecke, warum EquiSight die komplette App für dein Pferd ist.",
      keywords: [
        "Pferderverwaltungs-App",
        "Stallmanagement-App",
        "Pferde-Logbuch-App",
        "App für mehrere Pferde verwalten",
        "Stuten-Trächtigkeits-App",
        "Zucht-App Pferde",
        "beste Pferderverwaltungs-App",
      ],
    },
    hero: {
      eyebrow: "Entscheidungshilfe · Pferderverwaltungs-Software",
      breadcrumbLabel: "Pferderverwaltungs-App",
      title: "Pferderverwaltungs-App: die komplette Entscheidungshilfe für Besitzer, Ställe und Zuchten.",
      intro: "Nicht einfach eine Feature-Liste — ein ehrlicher Vergleich, eine Entscheidungshilfe und ein Blick darauf, was eine Pferderverwaltungs-App im Jahr 2026 wirklich können muss. Für ein Pferd, für einen ganzen Stall oder für deine Zucht.",
      pills: [
        {
          icon: "Users",
          label: "Für Besitzer",
        },
        {
          icon: "Building2",
          label: "Für Ställe",
        },
        {
          icon: "Baby",
          label: "Für Züchter",
        },
        {
          icon: "Share2",
          label: "Für Teams",
        },
      ],
      ctas: [
        {
          label: "Kostenlos mit 1 Pferd starten",
          href: "#start",
          primary: true,
        },
        {
          label: "Zur Vergleichstabelle",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Warum eine Pferderverwaltungs-App immer wichtiger wird.",
      lead: "Pferderverwaltung ist in der Praxis fragmentiert: WhatsApp, Kalender, Excel, Fotos auf dem Handy, ein Papierpass, lose Rechnungen und mündliche Absprachen. Bei einem Pferd schon umständlich. Bei mehreren Pferden, Zuchten oder geteilter Pflege entstehen Lücken, verpasste Termine und Diskussionen.",
      items: [
        "Wo stand dieses Impfdatum noch mal?",
        "Wer hat den Hufschmied bezahlt?",
        "Welche Stute muss heute kontrolliert werden?",
        "Hat der Trainer die Anweisung von letzter Woche gelesen?",
        "Habe ich dieses Foto-Dokument wirklich gespeichert?",
        "Stimmt der Fütterungsplan, der im Stall hängt, noch?",
      ],
    },
    what: {
      title: "Was ist eine Pferderverwaltungs-App?",
      lead: "Eine Pferderverwaltungs-App ist im Wesentlichen eine digitale Akte pro Pferd. Keine verstreuten Notizen, sondern ein zentraler Ort für Gesundheit, Training, Ernährung, Dokumente, Planung, Erinnerungen, Kosten, Fotos, Videos und gemeinsamen Zugriff. Alle rund um das Pferd sehen dieselben, aktuellen Informationen.",
      targetGroupsTitle: "Für wen ist eine Pferderverwaltungs-App gedacht?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privatbesitzer",
          body: "Ein Pferd, eine Akte — Gesundheit, Planung und Geschichte in der Hosentasche.",
        },
        {
          icon: "Users",
          title: "Besitzer mehrerer Pferde",
          body: "Separate Profile, separate Planung, gemeinsame Aufgabenliste für das gesamte Team.",
        },
        {
          icon: "Building2",
          title: "Pensionsstall & Reitanlage",
          body: "Besitzerzugang, Pflegeanweisungen, gemeinsamer Kalender und Aufgaben.",
        },
        {
          icon: "Baby",
          title: "Zucht",
          body: "Stutenzyklus, Trächtigkeit, Hengstdaten, Stammbaum und Fohlenentwicklung.",
        },
        {
          icon: "Target",
          title: "Trainer",
          body: "Einblick pro Pferd, Einheiten protokollieren, Ziele setzen, Videos analysieren.",
        },
        {
          icon: "ClipboardList",
          title: "Fachleute",
          body: "Hufschmied, Zahnarzt, Physiotherapeut oder Tierarzt — arbeiten aus derselben Akte.",
        },
      ],
    },
    criteria: {
      title: "Was muss eine gute Pferderverwaltungs-App erfüllen?",
      lead: "Eine App ist nicht nur schön — sie muss täglich praktisch funktionieren. Fünf Bereiche, die bei der Wahl 2026 nicht fehlen dürfen.",
      items: [
        {
          icon: "FileText",
          title: "Pferdeakte pro Pferd",
          body: "Daten, Alter, Rasse, Passinformationen, Besitzer, Stall, Fotos und Dokumente — alles mit einem Pferdeprofil verknüpft.",
        },
        {
          icon: "Heart",
          title: "Gesundheit und Pflege",
          body: "Impfungen, Entwurmung, Hufschmied, Zahnarzt, Tierarzt, Behandlungen, Medikamente und automatische Erinnerungen vor dem Ablaufdatum.",
        },
        {
          icon: "Activity",
          title: "Training und Fortschritt",
          body: "Trainings protokollieren, Notizen, Videos, Wettkampfergebnisse, Ziele und Fortschritt pro Disziplin oder pro Pferd.",
        },
        {
          icon: "Apple",
          title: "Ernährung und Management",
          body: "Fütterungspläne, Ergänzungsmittel, Raufutter, Gewicht, Körperkondition und die tägliche Routine, die der Stall kennen muss.",
        },
        {
          icon: "Share2",
          title: "Teilen mit anderen",
          body: "Zugang für Besitzer, Pfleger, Trainer, Stallbesitzer oder Fachleute — mit Rechteverwaltung, die zur jeweiligen Rolle passt.",
        },
        {
          icon: "Calendar",
          title: "Planung und Erinnerungen",
          body: "Ein gemeinsamer Kalender mit Aufgaben, automatischen Erinnerungen und Bestätigung, damit nichts durch die Maschen fällt.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. andere Pferderverwaltungs-Apps.",
      lead: "Die deutschen Suchergebnisse werden derzeit von Stalmanager, LogMyHorse, EquineM und Happie Horse gefüllt. Jede hat ihre Stärken. Wir stellen die meistgefragten Funktionen nebeneinander — ehrlich und auf Basis öffentlich verfügbarer Informationen.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Kostenlos starten",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Mehrere Pferde",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Gesundheitsakte",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Training & Fortschritt",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ernährung & Ergänzungsmittel",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planung & Erinnerungen",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumente pro Pferd",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Teilen mit Team & Rechte",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Zuchtmodul (vollständig)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Stutenzyklus",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Trächtigkeitsplanung + Ultraschall",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Fohlenentwicklung",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Fachleute integrieren",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach-Einblicke",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Geeignet für Besitzer",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Geeignet für Zucht",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Geeignet für Stall/Reitanlage",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Vergleich auf Basis öffentlich verfügbarer Funktionen im Januar 2026. Mitbewerber sind ebenfalls gute Tools; EquiSight wurde entwickelt, um alle Module in einer App zu vereinen.",
    },
    why: {
      title: "Warum EquiSight anders ist.",
      lead: "Ein Logbuch erfasst Daten. EquiSight kombiniert Pferderverwaltung, Training, Ernährung, Gesundheit, Wettkämpfe, Fachleute und Zucht in einer modernen App — und geht mit Einblicken einen Schritt weiter.",
      points: [
        {
          icon: "Heart",
          title: "Eine App für das gesamte Leben des Pferdes",
          body: "Vom Fohlen bis zum Sportpferd, zur Zuchtstute oder zum Rentenpferd. Die Akte wächst mit deinem Pferd — nichts geht unterwegs verloren.",
        },
        {
          icon: "Sparkles",
          title: "Nicht nur Daten, sondern auch Muster",
          body: "EquiCoach kombiniert Entwicklung, wiederkehrende Beschwerden, Training und Ernährung — damit du Signale rechtzeitig erkennst und keine Einzelmeldungen erhältst.",
        },
        {
          icon: "Share2",
          title: "Für Zusammenarbeit entwickelt",
          body: "Besitzer, Stallbesitzer, Trainer, Hufschmied und andere Fachleute arbeiten aus derselben Pferdeakte — mit den Rechten, die ihrer Rolle entsprechen.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nische · Zucht",
      title: "Pferderverwaltung für Züchter.",
      lead: "Viele Mitbewerber erwähnen Zucht in einer einzigen Zeile. EquiSight hat ein vollständiges Zuchtmodul entwickelt — weil der Züchter selten der Hauptnutzer einer allgemeinen App ist, aber die Planung mehr als jeder andere benötigt.",
      items: [
        "Stutenzyklus täglich verfolgen",
        "Besamungsdatum + Hengstdaten",
        "Trächtigkeitskontrolle mit Ultraschall",
        "Erwartetes Fohlengeburtsdatum + Warnungen",
        "Fohlenentwicklung pro Monat",
        "Stammbaum und Abstammung",
        "Notizen pro Stute",
        "Übersicht aller tragenden Stuten",
      ],
      ctaLabel: "Zuchtmodul ansehen",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nische · Stall & Reitanlage",
      title: "Pferderverwaltung für mehrere Pferde und Pensionsställe.",
      lead: "Bei mehreren Pferden geht es weniger um Daten und mehr um Kommunikation. Jeder Besitzer hat eigene Wünsche, Routinen, Fütterungsabsprachen und medizinische Besonderheiten. Jeder Mitarbeiter muss darauf ohne langes Suchen zugreifen können.",
      cards: [
        {
          t: "Pferde pro Besitzer",
          d: "Jeder Besitzer sieht nur seine Pferde.",
        },
        {
          t: "Pflegeanweisungen",
          d: "Pro Pferd sichtbar für den Stall.",
        },
        {
          t: "Gemeinsamer Kalender",
          d: "Hufschmied, Tierarzt und Wettkämpfe in einer Ansicht.",
        },
        {
          t: "Aufgabenliste",
          d: "Mitarbeitern zuweisen, mit Bestätigung.",
        },
        {
          t: "Besitzerzugang",
          d: "Kunden sehen ihr Pferd in der eigenen App.",
        },
        {
          t: "Notfallkontakte",
          d: "Im Stressfall im Stall immer auffindbar.",
        },
      ],
      ctaLabel: "Reitanlagenmodul ansehen",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Von WhatsApp, Excel und Whiteboard zu EquiSight.",
      lead: "Konkret: So verändert sich deine tägliche Pferderverwaltung.",
      rows: [
        {
          before: "WhatsApp-Gruppen",
          after: "Strukturierte Notizen pro Pferd",
        },
        {
          before: "Excel-Tabellen",
          after: "Live-Pferdeakte mit Verlauf",
        },
        {
          before: "Whiteboard im Stall",
          after: "Gemeinsame Planung auf dem Handy",
        },
        {
          before: "Lose Fotos in der Kamera",
          after: "Medien verknüpft mit deinem Pferd",
        },
        {
          before: "Mündliche Absprachen",
          after: "Aufgaben und Erinnerungen mit Bestätigung",
        },
        {
          before: "Papierpass verlegt",
          after: "Dokumente immer griffbereit",
        },
      ],
    },
    helper: {
      title: "Welche Pferderverwaltungs-App passt zu dir?",
      lead: "Beantworte diese 5 Fragen und erhalte eine ehrliche Empfehlung — auch wenn es nicht immer EquiSight ist.",
      questions: [
        {
          id: "horses",
          q: "Hast du ein Pferd oder mehrere Pferde?",
          options: [
            {
              label: "Ein Pferd",
              score: 1,
            },
            {
              label: "2–5 Pferde",
              score: 2,
            },
            {
              label: "Mehr als 5 Pferde",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Verwaltest du Pferde von Kunden oder Dritten?",
          options: [
            {
              label: "Nein, nur meine eigenen Pferde",
              score: 0,
            },
            {
              label: "Manchmal — für Familie oder Bekannte",
              score: 1,
            },
            {
              label: "Ja, professionell (Stall / Reitanlage)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Möchtest du Zucht und Trächtigkeit verfolgen?",
          options: [
            {
              label: "Nicht relevant",
              score: 0,
            },
            {
              label: "Manchmal — gelegentliche Zucht",
              score: 1,
            },
            {
              label: "Ja, ich bin (oder werde) Züchter",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Arbeitest du mit Trainer, Pfleger oder Fachleuten zusammen?",
          options: [
            {
              label: "Nein, ich mache alles selbst",
              score: 0,
            },
            {
              label: "Ja, mit 1 Person",
              score: 1,
            },
            {
              label: "Ja, mit mehreren Personen",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Möchtest du nur erfassen oder auch Einblicke gewinnen?",
          options: [
            {
              label: "Nur erfassen",
              score: 1,
            },
            {
              label: "Erfassen + Planung",
              score: 2,
            },
            {
              label: "Erfassen + Planung + Einblicke",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ein einfaches Logbuch reicht — und wächst mit dir mit.",
          body: "Für ein Pferd ohne geteilte Pflege ist jede Pferderverwaltungs-App geeignet. EquiSight startet kostenlos mit 1 Pferd, also gehst du kein Risiko ein. Möchtest du später weitere Pferde, einen Trainer oder Zucht hinzufügen, ist alles bereits enthalten.",
          cta: "Kostenlos mit 1 Pferd starten",
        },
        mid: {
          title: "EquiSight passt gut zu deiner Situation.",
          body: "Du hast mehrere Bedürfnisse (mehrere Pferde, Zusammenarbeit oder Einblicke). Die meisten Mitbewerber decken 1–2 Module ab; EquiSight kombiniert sie in einer App, ohne dass du separate Tools verknüpfen musst.",
          cta: "Entdecke, was EquiSight kann",
        },
        high: {
          title: "EquiSight ist die naheliegendste Wahl.",
          body: "Deine Situation kombiniert mehrere Pferde, Zusammenarbeit, Zucht und/oder Einblicke. Genau hier macht EquiSight den Unterschied — keine verstreuten Tools, sondern eine Pferdeakte für alles und alle rund um das Pferd.",
          cta: "Kostenlos mit EquiSight starten",
        },
      },
    },
    faqTitle: "Häufig gestellte Fragen zu Pferderverwaltungs-Apps",
    faq: [
      {
        q: "Was ist die beste Pferderverwaltungs-App?",
        a: "Die beste Pferderverwaltungs-App hängt von deiner Situation ab. Für ein einfaches Logbuch sind mehrere Apps geeignet. Möchtest du Gesundheit, Training, Ernährung, Dokumente, Zucht, Planung und Zusammenarbeit kombinieren, ist EquiSight als vollständige Lösung entwickelt worden, bei der alles in einer Akte zusammenkommt.",
      },
      {
        q: "Kann ich mehrere Pferde in einer App verwalten?",
        a: "Ja. Eine gute Pferderverwaltungs-App muss mehrere Pferde unterstützen, einschließlich Besitzer, Pfleger, Routinen, Dokumente, Termine und Erinnerungen pro Pferd. EquiSight ist von der ersten Zeile Code an darauf ausgelegt — Pferde sind individuelle Akten, keine Zeilen in einer Liste.",
      },
      {
        q: "Ist EquiSight auch für Züchter geeignet?",
        a: "Ja. EquiSight kann mit Zuchtfunktionen eingerichtet werden, wie Stutenzyklus, Besamungsdatum, Trächtigkeitskontrolle, Hengstdaten, Stammbaum, erwartetes Fohlengeburtsdatum und Fohlenentwicklung. Genau das ist der Bereich, auf den die meisten Mitbewerber-Apps kaum oder gar nicht eingehen.",
      },
      {
        q: "Kann ich Daten mit meinem Trainer oder Hufschmied teilen?",
        a: "Ja. Das Ziel von EquiSight ist es, dass relevante Informationen sicher mit Personen rund um das Pferd geteilt werden können — Trainer, Hufschmied, Zahnarzt, Tierarzt, Physiotherapeut, Pfleger oder Besitzer. Jede Person erhält nur die Rechte, die für ihre Rolle erforderlich sind.",
      },
      {
        q: "Warum nicht einfach WhatsApp oder Excel verwenden?",
        a: "WhatsApp und Excel funktionieren, solange es einfach bleibt. Sobald du mehrere Pferde, Termine, Dokumente, Behandlungen, Besitzer oder Zuchtdaten hast, wird es fehleranfällig: Informationen verteilen sich, die Suche kostet Zeit und mündliche Absprachen gehen verloren. Eine Pferderverwaltungs-App bündelt alles pro Pferd mit automatischen Erinnerungen.",
      },
      {
        q: "Was kostet EquiSight?",
        a: "Du kannst kostenlos mit 1 Pferd starten. Möchtest du mehrere Pferde verwalten, die Zuchtfunktion aktivieren oder Fachleuten Zugang gewähren, gibt es günstige Premium-Pläne. Die aktuellen Optionen findest du auf der Preisseite.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Zuchtprogramm Software Pferd: vollständiger Vergleich 2026",
      description: "Vergleiche Zuchtprogramm-Software für Pferde: Stutenzyklus, Trächtigkeit, Hengstauswahl und Fohlen. Entdecke, warum EquiSight die komplette Zucht-App ist.",
      keywords: [
        "Zuchtprogramm Software Pferd",
        "Stutenzyklus App",
        "Stutenträchtigkeit App",
        "Fohlenregistrierung App",
        "Zuchtbuch App Pferd",
        "Deckplanung Pferd",
        "Hengstauswahl App",
      ],
    },
    hero: {
      eyebrow: "Entscheidungshilfe · Zuchtprogramm Software",
      breadcrumbLabel: "Zuchtprogramm Software",
      title: "Zuchtprogramm Software für Pferde: der vollständige Vergleich für 2026.",
      intro: "Eine Zuchtstute verdient mehr als eine allgemeine Pferdenverwaltungs-App. Vergleiche die Zuchtfunktionen der bekanntesten Tools, entdecke, worauf es wirklich ankommt, und wähle bewusst die Software, die zu deinem Gestüt passt – groß oder klein.",
      pills: [
        {
          icon: "Baby",
          label: "Stutenzyklus",
        },
        {
          icon: "Heart",
          label: "Trächtigkeitskontrolle",
        },
        {
          icon: "Sparkles",
          label: "Fohlenentwicklung",
        },
        {
          icon: "FileText",
          label: "Zuchtbuch",
        },
      ],
      ctas: [
        {
          label: "Kostenlos mit dem Zuchtmodul starten",
          href: "#start",
          primary: true,
        },
        {
          label: "Zur Vergleichstabelle",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Warum eine gewöhnliche Pferdenverwaltungs-App für die Zucht nicht ausreicht.",
      lead: "Die meisten Pferdesport-Apps sind für ein einzelnes Sport- oder Freizeitpferd konzipiert. Ein Zuchtbetrieb hat einen ganz anderen Rhythmus: Rosse, Besamung, Trächtigkeitskontrolle, Ultraschall, Fohlenkalender, Stammbaum und Verkauf. Eine Excel-Tabelle gerät nach 2 Saisons aus dem Gleichgewicht – und bei mehreren Stuten verlierst du den Überblick.",
      items: [
        "Wann war noch mal der letzte Zyklus von Bonita?",
        "Welcher Hengst ist für die Bedeckung in der nächsten Saison geplant?",
        "Ist die 21-Tage-Ultraschalluntersuchung bereits eingeplant?",
        "Welche Fohlen von 2024 wurden bereits verkauft?",
        "Wo ist das Stammbaum-Diagramm bis zum Großvater mütterlicherseits?",
        "Wo sind die DNA-Proben und Passdaten?",
      ],
    },
    what: {
      title: "Was ist Zuchtprogramm Software für Pferde?",
      lead: "Zuchtprogramm Software ist eine spezialisierte Akte pro Stute und Hengst, kombiniert mit einem Zuchtjahreskalender, Trächtigkeitsplanung, Fohlenregistrierung und Stammbaum-Ansicht. Kein allgemeines Pferdetagebuch, sondern ein Tool, das den Zuchtzyklus versteht: von der ersten Rosse bis zum Absetzen.",
      targetGroupsTitle: "Für welche Art von Züchter ist Zuchtprogramm Software gedacht?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobbyzüchter (1–3 Stuten)",
          body: "Ein oder zwei Bedeckungen pro Jahr – Übersicht ohne Excel-Akrobatik.",
        },
        {
          icon: "Building2",
          title: "Kleines Gestüt (4–10 Stuten)",
          body: "Ein Zuchtjahresplan mit Zyklus, Besamung, Trächtigkeitskontrollen und Fohlendossier.",
        },
        {
          icon: "Users",
          title: "Professionelles Gestüt (10+)",
          body: "Mehrere Mitarbeiter, Hengstauswahl pro Stute, Verkauf und Marketing.",
        },
        {
          icon: "Target",
          title: "Hengsthalter",
          body: "Bestellhistorie, Sperma-Statistiken und Terminkalender pro Hengst.",
        },
        {
          icon: "Heart",
          title: "Embryotransfer",
          body: "Donor- und Empfängerstute als verknüpfte Akte, ET-Kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Zuchtbucheintragung",
          body: "DNA-Proben, Passdokumente und Zuchtbuchdaten.",
        },
      ],
    },
    criteria: {
      title: "Was muss gute Zuchtprogramm Software leisten?",
      lead: "Nicht jede 'Zuchtfunktion' in einer Pferde-App ist gleichwertig. Fünf Kernbereiche, in denen Züchter viel Zeit verlieren – und wo Software wirklich den Unterschied macht.",
      items: [
        {
          icon: "Calendar",
          title: "Stutenzyklus & Rosse",
          body: "Tägliches Protokoll, vorausschauende Ovulation, Zyklusfortschritt und automatische Erinnerungen.",
        },
        {
          icon: "Heart",
          title: "Besamung & Trächtigkeitskontrolle",
          body: "Deck- und Besamungsdaten, Hengstdaten, 14-Tage-Ultraschall, 21-Tage-Ultraschall, 60-Tage-Ultraschall und Geschlechtsbestimmung.",
        },
        {
          icon: "Baby",
          title: "Fohlenentwicklung",
          body: "Geburtsdaten, Gewichtskurve, Entwurmungsplan, Absetztermin, Passregistrierung.",
        },
        {
          icon: "FileText",
          title: "Stammbaum & Dokumente",
          body: "Stammbaum-Ansicht bis zu 4–5 Generationen, DNA, Passnummern und Zuchtbuchstatus.",
        },
        {
          icon: "Target",
          title: "Hengstauswahl & Matching",
          body: "Filtern nach Disziplin, Linien, Hengstdaten und historischem Erfolg – nicht nur das, was ein Hengsthalter bewirbt.",
        },
        {
          icon: "Share2",
          title: "Zusammenarbeit mit Tierarzt/Besamungstechniker",
          body: "Ultraschallbefunde, Proben und Status direkt mit der Praxis geteilt, die an deinen Stuten arbeitet.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andere Zuchtprogramm Software.",
      lead: "Die deutschen Suchergebnisse für Zuchtprogramm Software zeigen oft generische Pferde-Apps, die Zucht in einem Satz erwähnen. Wir vergleichen fair, welche Tools wirklich einen vollständigen Zucht-Workflow bieten.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Kostenlos starten",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Stutenzyklus protokollieren",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Besamungsdatum + Hengst",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultraschall & Trächtigkeitskontrolle",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Voraussichtliches Geburtsdatum",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fohlendossier (Gewicht/Wachstum)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Stammbaum bis 4–5 Generationen",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & Passregistrierung",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Hengstauswahl / Matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / Embryotransfer",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Übersicht mehrerer Stuten",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Teilen mit Tierarzt",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integriert mit allgemeiner Akte",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Verkauf & Marketing von Fohlen",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Vergleich auf Basis öffentlich verfügbarer Funktionen im Januar 2026. EquineGenie ist stark in der Zucht, aber weniger bei Mobil + allgemeiner Pferdenverwaltung. EquiSight kombiniert beides.",
    },
    why: {
      title: "Warum EquiSight Züchter anders betreut.",
      lead: "Viele Züchter arbeiten mit separater Zuchtprogramm Software und einer gesonderten Pferdenverwaltungs-App. EquiSight kombiniert beides – ohne dass du zwischen Apps wechselst oder Daten doppelt eingibst.",
      points: [
        {
          icon: "Heart",
          title: "Zuchtstute bleibt auch ein normales Pferd",
          body: "Die Zuchtstute hat ein Zuchtjahr und eine normale Pferdeakte – Gesundheit, Impfungen, Hufschmied. Eine App, alle Module.",
        },
        {
          icon: "Sparkles",
          title: "Vorausschauend statt reaktiv",
          body: "Zyklusvorhersage, Trächtigkeits-Meilenstein-Erinnerungen und Fohlenkalender – automatisch auf Basis deiner Daten.",
        },
        {
          icon: "Share2",
          title: "Alle rund um die Zucht",
          body: "Besamungstechniker, Hengsthalter, Tierarzt, Käufer, Zuchtbuch – alle haben Zugang mit den passenden Rechten.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Pro Disziplin · vom Zyklus bis zum Absetzen",
      title: "Was eine Zuchtakte in EquiSight enthält.",
      lead: "Pro Stute erhältst du eine vollständige Zuchtakte, verknüpft mit ihrer regulären Pferdeakte.",
      items: [
        "Tägliches Zyklusprotokoll mit Vorhersage",
        "Besamung/Bedeckung + Hengstdaten",
        "Ultraschall-Zeitlinie (14/21/60 Tage + Geschlecht)",
        "Trächtigkeits-Meilensteine mit automatischen Erinnerungen",
        "Voraussichtliches Geburtsdatum und Vorbereitung",
        "Fohlendossier ab Geburt",
        "Stammbaum bis Groß-/Großmutter mit Klick-Navigation",
        "DNA-Probe, Pass, Zuchtbuchstatus",
        "Verkaufspipeline mit Interessentenliste",
        "Hengstauswahl-Historie pro Stute",
      ],
      ctaLabel: "Zuchtmodul ansehen",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Für das gesamte Gestüt",
      title: "Übersicht für mehrere Stuten und Hengste.",
      lead: "Wenn du mehr als 2–3 Stuten züchtest, wird der Überblick über alle Zyklen und Trächtigkeiten entscheidend.",
      cards: [
        {
          t: "Zyklus-Dashboard",
          d: "Alle Stuten nebeneinander, mit Zyklusphase und nächster Maßnahme.",
        },
        {
          t: "Trächtigkeits-Pipeline",
          d: "Welche Stuten befinden sich wo bei den Trächtigkeits-Meilensteinen?",
        },
        {
          t: "Fohlenkalender",
          d: "Voraussichtliche Geburten pro Monat, mit entsprechend abgestimmter Logistik.",
        },
        {
          t: "Hengst-Portfolio",
          d: "Eigene Hengste oder feste Besamungstechniker mit Bestellhistorie.",
        },
        {
          t: "Stammbaum-Grafik",
          d: "Vorfahren-Analyse über mehrere Generationen und Linien.",
        },
        {
          t: "Verkaufs-Dashboard",
          d: "Welche Fohlen sind verkauft, reserviert oder noch verfügbar.",
        },
      ],
    },
    beforeAfter: {
      title: "Von Excel + Kalender zu EquiSight Zucht.",
      lead: "Konkret: So verändert sich deine Zuchtsaison.",
      rows: [
        {
          before: "Zyklus in loser Notiz",
          after: "Tägliches Protokoll mit Vorhersage",
        },
        {
          before: "Ultraschallbefunde per WhatsApp an den Besamungstechniker",
          after: "Gemeinsame Akte mit Fotos",
        },
        {
          before: "Trächtigkeitsdatum im Kalender",
          after: "Automatische Meilenstein-Erinnerungen",
        },
        {
          before: "FohlenpPass in der Schublade",
          after: "Dokument verknüpft mit Fohlenprofil",
        },
        {
          before: "Stammbaum auf Papier",
          after: "Anklickbarer Stammbaum bis 4–5 Generationen",
        },
        {
          before: "Verkaufsanzeige auf Marktplaats",
          after: "Verkaufspipeline mit Interessentenliste",
        },
      ],
    },
    helper: {
      title: "Welche Zuchtprogramm Software passt zu dir?",
      lead: "5 Fragen, um herauszufinden, ob du eine vollständige Zucht-App benötigst oder ein Hobby-Tool ausreicht.",
      questions: [
        {
          id: "mares",
          q: "Wie viele Zuchtstuten betreust du?",
          options: [
            {
              label: "1 Stute",
              score: 1,
            },
            {
              label: "2–5 Stuten",
              score: 2,
            },
            {
              label: "Mehr als 5 Stuten",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Wie oft züchtest du pro Jahr?",
          options: [
            {
              label: "Gelegentlich (alle paar Jahre)",
              score: 0,
            },
            {
              label: "Jedes Jahr 1–2 Bedeckungen",
              score: 2,
            },
            {
              label: "Jedes Jahr 3+ Bedeckungen",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Wie besamst/bedeckst du?",
          options: [
            {
              label: "Natursprung",
              score: 1,
            },
            {
              label: "KB mit Frisch-/Kühls­perma",
              score: 2,
            },
            {
              label: "ET oder Tiefgefriersperma",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Arbeitest du mit Tierarzt/Besamungstechniker zusammen?",
          options: [
            {
              label: "Eine feste Person",
              score: 1,
            },
            {
              label: "Mehrere Praxen",
              score: 2,
            },
            {
              label: "Internationales Netzwerk",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Was erfasst du derzeit?",
          options: [
            {
              label: "Excel oder Papier",
              score: 1,
            },
            {
              label: "Allgemeine Pferdenverwaltungs-App",
              score: 2,
            },
            {
              label: "Nichts Strukturiertes",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ein Hobby-Tool oder Excel reicht aus – EquiSight bleibt aber praktisch.",
          body: "Für 1 Stute mit Natursprung alle paar Jahre ist ein umfangreiches Zuchtmodul überdimensioniert. EquiSight startet kostenlos, und du aktivierst das Zuchtmodul nur für das Jahr, in dem du züchtest – ohne Upgrade-Pflicht.",
          cta: "Kostenlos starten",
        },
        mid: {
          title: "EquiSight Zucht ist das richtige Tool.",
          body: "Du hast mehrere Stuten oder mehrere Zuchtmethoden – dafür sind allgemeine Pferde-Apps nicht ausgelegt. EquiSight kombiniert Zucht + allgemeine Pflege, sodass du nicht zwischen zwei Tools wechselst.",
          cta: "Zuchtmodul ansehen",
        },
        high: {
          title: "EquiSight ist für dein Gestüt gebaut.",
          body: "Mehrere Stuten, ET oder Tiefgefriersperma, internationales Team – die meisten Tools stoßen hier an ihre Grenzen. EquiSight skaliert bis auf Gestüts-Niveau, ohne dass du zusätzliche Lizenzen stapelst.",
          cta: "Sprich mit uns über einen Gestüts-Plan",
        },
      },
    },
    faqTitle: "Häufig gestellte Fragen zur Zuchtprogramm Software",
    faq: [
      {
        q: "Was ist die beste Zuchtprogramm Software für Pferde?",
        a: "Für 1 Stute ohne komplizierte Zuchtmethode reichen viele Tools aus. Ab 2–3 Stuten, Einsatz von KB oder ET oder Zusammenarbeit mit Tierarzt und Zuchtbuch wird ein vollständiges Zuchtmodul unverzichtbar. EquiSight kombiniert Zucht mit allgemeiner Pferdenverwaltung in einer App, sodass du nicht wechseln musst.",
      },
      {
        q: "Welche Zuchtfunktionen brauche ich wirklich?",
        a: "Mindestens: Zyklusprotokoll, Besamungs-/Bedeckungsdaten, Trächtigkeits-Meilensteine und Fohlendossier. Optional, aber leistungsstark: Stammbaum-Ansicht, Hengstauswahl-Archiv, DNA/Pass und Verkaufspipeline.",
      },
      {
        q: "Kann EquiSight den Zyklus einer Stute vorhersagen?",
        a: "Ja. EquiSight nutzt frühere Zyklusdaten, um die voraussichtliche Ovulation anzuzeigen, sodass du Besamung oder Bedeckung zum richtigen Zeitpunkt planst – ohne tägliches Rätseln.",
      },
      {
        q: "Funktioniert EquiSight auch für Embryotransfer?",
        a: "Ja. Donor- und Empfängerstute erhalten verknüpfte Akten, einen ET-Kalender und gemeinsame Meilensteine mit der Praxis. So verlierst du keine Zeitlinie im komplexen ET-Ablauf.",
      },
      {
        q: "Kann ich meine vorhandenen Zuchtdaten importieren?",
        a: "Du kannst Zyklen, Bedeckungen und Fohlendaten manuell eingeben oder per CSV als Batch importieren. Bei aktiven Zuchtbetrieben helfen wir mit einer einmaligen Migration, wenn du Daten über mehrere Saisons gespeichert hast.",
      },
      {
        q: "Wie teile ich die Akte mit meinem Tierarzt oder Besamungstechniker?",
        a: "Jede Person erhält Zugang mit einer Rolle: Tierarzt, Besamungstechniker, Hengsthalter oder Zuchtbuch-Funktionär. Jeder sieht nur die Informationen, die für seine Rolle erforderlich sind – kein vollständiger Zugang nötig.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Reitstall Software: vollständiger Vergleich & Entscheidungshilfe 2026",
      description: "Vergleiche Reitstall-Software für Unterricht, Reiter, Pferde und Verwaltung. Entdecke, welche App zu deinem Reit- oder Pensionsstall passt.",
      keywords: [
        "Reitstall Software",
        "Stallmanagement App",
        "Reitstall Verwaltungssoftware",
        "Unterrichtsplanung Reitstall",
        "Pensionsstall Software",
        "Reiter Verwaltung",
        "Pferde Verwaltung Reitstall",
      ],
    },
    hero: {
      eyebrow: "Entscheidungshilfe · Reitstall Software",
      breadcrumbLabel: "Reitstall Software",
      title: "Reitstall Software: die vollständige Entscheidungshilfe für Reit- und Pensionsställe.",
      intro: "Unterrichtsplanung, Reiterverwaltung, Pferdemanagement, Rechnungsstellung und Kommunikation – gute Reitstall-Software bringt alles zusammen. Vergleiche die bekanntesten Optionen und entdecke, welche zu deinem Stall oder Reitstall passt.",
      pills: [
        {
          icon: "Calendar",
          label: "Unterrichtsplanung",
        },
        {
          icon: "Users",
          label: "Reiter & Kunden",
        },
        {
          icon: "Heart",
          label: "Pferdepflege",
        },
        {
          icon: "CreditCard",
          label: "Rechnungsstellung",
        },
      ],
      ctas: [
        {
          label: "Demo anfragen",
          href: "#start",
          primary: true,
        },
        {
          label: "Zur Vergleichstabelle",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Warum verstreute Tools einen Reitstall ausbremsen.",
      lead: "Die meisten Reitställe arbeiten mit einem Flickenteppich: Unterrichtsplanung auf dem Whiteboard, Reiterregistrierung in Excel, Rechnungsstellung in einem zweiten Tool, Pferdepflege über WhatsApp und Eigentümerkontakt per privaten Nachrichten. In einer vollen Woche entstehen Doppelbuchungen, vergessene Rechnungen oder Pferde, die nicht wissen, welcher Reiter kommt.",
      items: [
        "Wer hat gerade Unterricht bei Jasmijn?",
        "Welcher Reiter hat für März noch nicht bezahlt?",
        "Welches Pferd darf diese Woche nicht eingesetzt werden?",
        "Wer sind die Notfallkontakte der Schüler?",
        "Hat der Eigentümer von Stardust die Hufschmiedrechnung erhalten?",
        "Welches Pferd steht in welcher Box?",
      ],
    },
    what: {
      title: "Was ist Reitstall-Software?",
      lead: "Reitstall-Software kombiniert Unterrichtsplanung, Reiterverwaltung, Pferdemanagement, Rechnungsstellung und Kommunikation in einem einzigen Tool. Kein Excel-Jonglieren oder WhatsApp-Chaos, sondern ein zentraler Ort, an dem der Stall arbeitet und Eigentümer sowie Reiter mitverfolgen können.",
      targetGroupsTitle: "Für welche Art von Betrieb ist Reitstall-Software gedacht?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Kleiner Reitstall (1–15 Pferde)",
          body: "Vor allem Unterrichtsplanung und Zahlungen – Verwaltung ohne Kopfschmerzen.",
        },
        {
          icon: "Users",
          title: "Mittelgroßer Reitstall (15–40 Pferde)",
          body: "Mehrere Trainer, Unterrichtsplanung + Pferdedienstplan + Reiterverwaltung.",
        },
        {
          icon: "ClipboardList",
          title: "Großer Reit- und Pensionsstall (40+)",
          body: "Vollständiger Betrieb inklusive Rechnungsstellung, Futter- und Hufschmiedplanung.",
        },
        {
          icon: "Heart",
          title: "Pensionsstall",
          body: "Eigentümerportal, individuelle Pflegeanweisungen, geteilter Kalender.",
        },
        {
          icon: "Target",
          title: "Springreiter-Trainingsstall",
          body: "Turnierplanung, pferdeindividuelles Training, Kundenkontakt.",
        },
        {
          icon: "FileText",
          title: "Hippische Unternehmer",
          body: "Mix aus Unterricht + Pension + Clinic + Handel – alles aus einem System.",
        },
      ],
    },
    criteria: {
      title: "Was muss gute Reitstall-Software können?",
      lead: "Eine schöne App nützt nichts, wenn deine Mitarbeiter nicht damit arbeiten möchten. Fünf praktische Kriterien, die den Unterschied zwischen Erfolg und Frustration ausmachen.",
      items: [
        {
          icon: "Calendar",
          title: "Unterrichtsplanung auf mehreren Ebenen",
          body: "Anfänger/Fortgeschrittene, Dressur/Springen, Pferdezuweisungen und Trainerkalender – alles auf einen Blick.",
        },
        {
          icon: "Users",
          title: "Reiterverwaltung",
          body: "Profile, Niveau, Abonnement, Reiterkarte und Familienmitglied-Verknüpfungen für Jungreiter.",
        },
        {
          icon: "Heart",
          title: "Pferdedienstplan",
          body: "Welches Pferd wird wie oft eingesetzt – mit Ruhe-, Verletzungs- und Zyklusperioden.",
        },
        {
          icon: "CreditCard",
          title: "Rechnungsstellung & Abonnements",
          body: "Monatliche Abonnements, Reiterkarten, Einzelstunden und automatisches Lastschriftverfahren.",
        },
        {
          icon: "Share2",
          title: "Eigentümerportal (Pensionsstall)",
          body: "Eigentümer sehen ihr Pferd in der eigenen App – Kalender, Kosten, Hufschmied und Notizen ohne Anrufe.",
        },
        {
          icon: "Bell",
          title: "Kommunikation & Erinnerungen",
          body: "Automatische Unterrichtserinnerungen, Zahlungsbenachrichtigungen, Hufschmied-Ankündigungen – ohne Messenger.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. andere Reitstall-Software.",
      lead: "Viele Reitstall-Tools sind stark in der Unterrichtsplanung oder Rechnungsstellung, aber selten gleichzeitig in Pferdepflege und Eigentümerkommunikation. Wir stellen sie ehrlich nebeneinander.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Kostenlos starten / Testzeitraum",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Unterrichtsplanung",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Mehrere Trainer",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Reiterverwaltung",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Pferdedienstplan",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pferdepflege (Impfung/Hufschmied)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Reiterkarte / Abonnement",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online-Zahlungen",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatische Rechnungsstellung",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Eigentümerportal (Pension)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hufschmied/Tierarzt-Integration",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS-Erinnerungen",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Turnierplanung",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Geeignet für Pensionsstall",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Vergleich basierend auf öffentlich verfügbaren Funktionen im Januar 2026. Stalmanager ist stark in der Verwaltung, EquiSight hebt sich durch den Pensionsstall-Workflow, Pferdepflege und das Eigentümerportal ab.",
    },
    why: {
      title: "Warum EquiSight für Reit- und Pensionsställe anders ist.",
      lead: "EquiSight geht über einen einfachen Stundenplaner hinaus. Wir betrachten einen Reitstall als vollständigen Betrieb: Pferde, Menschen, Kommunikation und Finanzen – alles voneinander abhängig.",
      points: [
        {
          icon: "Heart",
          title: "Das Pferd im Mittelpunkt, nicht der Kalender",
          body: "Jedes Pferd hat seine eigene Akte. Unterrichtseinsatz, Gesundheit, Hufschmied und Turniere in einer Zeitlinie – nicht in 3 separaten Tools.",
        },
        {
          icon: "Share2",
          title: "Eigentümer informiert ohne Anrufe",
          body: "Pensionsstall-Eigentümer haben ihre eigene Ansicht: Kosten, Planung, Fotos und Notizen – das spart 5–10 Anrufe pro Woche.",
        },
        {
          icon: "Bell",
          title: "Automatische Kommunikation",
          body: "Unterrichtserinnerung, Impferinnerung, Rechnung – automatisch, per App/E-Mail/SMS. Kein Massen-WhatsApp mehr.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Für den Pensionsstall",
      title: "Was ein Pensionsstall mit EquiSight bekommt.",
      lead: "Pensionsställe haben besondere Herausforderungen, die normale Reitstall-Software nicht löst.",
      cards: [
        {
          t: "Eigentümerportal",
          d: "Jeder Eigentümer sieht nur sein Pferd bzw. seine Pferde, Kalender und Kosten.",
        },
        {
          t: "Pflegeanweisungen pro Pferd",
          d: "Kraftfutter, Raufutter, Ergänzungsmittel, Deckenplan – für den Stall sichtbar.",
        },
        {
          t: "Geteilter Kalender",
          d: "Hufschmied, Tierarzt und Eigentümerbesuche in einer Ansicht.",
        },
        {
          t: "Verbrauchskosten pro Pferd",
          d: "Einstreu, Futter, Kraftfutter je Eigentümer abgerechnet.",
        },
        {
          t: "Notfallkontakte Pferd",
          d: "Eigentümer, Tierarzt und Hufschmied immer für den Stall auffindbar.",
        },
        {
          t: "Weidegangverwaltung",
          d: "Welche Pferde gehen auf die Weide, sind in Ruhe oder in Rehabilitation?",
        },
      ],
    },
    beforeAfter: {
      title: "Von Whiteboard + Excel zu EquiSight.",
      lead: "Konkret: So verändert sich eine Arbeitswoche im Reitstall.",
      rows: [
        {
          before: "Whiteboard mit der Unterrichtsplanung",
          after: "Live-Planung pro Trainer",
        },
        {
          before: "Excel mit Reitern und Unterrichtsnotizen",
          after: "Kunden-CRM mit Unterrichtsverlauf",
        },
        {
          before: "WhatsApp an Eigentümer",
          after: "Eigentümerportal für ihr Pferd",
        },
        {
          before: "Monatliches Lastschriftverfahren manuell",
          after: "Automatische Rechnungsstellung + iDEAL",
        },
        {
          before: "Pferdepflege auf einem Papier-Pinnboard",
          after: "Pflegeanweisungen pro Pferd, geteilt",
        },
        {
          before: "Mündliche Absprache mit dem Hufschmied",
          after: "Hufschmiedplanung mit Bestätigungen",
        },
      ],
    },
    helper: {
      title: "Welche Reitstall-Software passt zu dir?",
      lead: "5 Fragen, um herauszufinden, ob EquiSight die richtige Plattform für deinen Reit- oder Pensionsstall ist.",
      questions: [
        {
          id: "size",
          q: "Wie viele Pferde hast du in deinem Betrieb?",
          options: [
            {
              label: "Weniger als 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Mehr als 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Was ist deine Haupttätigkeit?",
          options: [
            {
              label: "Vor allem Unterricht geben",
              score: 1,
            },
            {
              label: "Pensionsstall (Pferde in Pension)",
              score: 3,
            },
            {
              label: "Mix aus Unterricht + Pension",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Mit wie vielen Trainern arbeitest du?",
          options: [
            {
              label: "Nur ich selbst",
              score: 1,
            },
            {
              label: "2–3 Trainer",
              score: 2,
            },
            {
              label: "4 oder mehr",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Wie regelst du aktuell deine Rechnungsstellung?",
          options: [
            {
              label: "Manuell (Word/Excel)",
              score: 3,
            },
            {
              label: "Separates Buchhaltungsprogramm",
              score: 2,
            },
            {
              label: "Integriert im Unterrichtstool",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Wie kommunizierst du mit Eigentümern?",
          options: [
            {
              label: "Persönlich / WhatsApp",
              score: 3,
            },
            {
              label: "E-Mail + WhatsApp",
              score: 2,
            },
            {
              label: "Eigentümerportal im Tool",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ein einfaches Tool oder Excel reicht vorerst – aber EquiSight wächst mit.",
          body: "Für einen kleinen Unterrichtsbetrieb mit einem Trainer und wenig Pensionshaltung ist ein umfangreiches Paket nicht sofort notwendig. EquiSight startet kostenlos und wächst mit deinem Stall – kein aufwändiger Wechsel in ein paar Jahren.",
          cta: "Kostenlos starten",
        },
        mid: {
          title: "EquiSight ist ein logisches Upgrade für deinen Reitstall.",
          body: "Mehrere Trainer, ein Mix aus Unterricht und Pension oder eine bisher getrennte Rechnungsstellung – EquiSight bündelt das in einem Arbeitsablauf. Besonders das Eigentümerportal reduziert viel Ad-hoc-Kommunikation.",
          cta: "Demo anfragen",
        },
        high: {
          title: "EquiSight ist für deine Größenordnung gebaut.",
          body: "Pensionsstall + Unterricht + mehrere Trainer ist genau das, womit sich EquiSight von klassischer Reitstall-Software unterscheidet. Das Eigentümerportal und die Pferdepflege-Integration sparen wöchentlich Stunden an Verwaltung und Kommunikation.",
          cta: "Demo für deinen Stall planen",
        },
      },
    },
    faqTitle: "Häufig gestellte Fragen zur Reitstall-Software",
    faq: [
      {
        q: "Was ist die beste Reitstall-Software?",
        a: "Für reine Unterrichtsplanung gibt es mehrere gute Optionen. Sobald du einen Pensionsstall, mehrere Trainer oder Pferdepflege-Tracking benötigst, wird EquiSight zur vollständigen Lösung – kein Tool-Jonglieren, alles an einem Ort.",
      },
      {
        q: "Kann ich bestehende Kunden und Unterrichtsstunden importieren?",
        a: "Ja. Kundendaten und Unterrichtspläne können per CSV importiert werden. Wir unterstützen aktive Reitställe mit einer einmaligen Migration, damit du nicht 200 Reiter manuell eingeben musst.",
      },
      {
        q: "Funktioniert es auch für einen Pensionsstall ohne Unterricht?",
        a: "Ja. Der Pensionsstall-Modus deaktiviert die Unterrichtsfunktionen und konzentriert sich auf Eigentümerportal, Futter/Pflege, Hufschmiedplanung und die Abrechnung von Kosten pro Pferd.",
      },
      {
        q: "Können Reiter sich selbst einschreiben und bezahlen?",
        a: "Ja. Reiter können über ein eigenes Konto sehen, welche Stunden verfügbar sind, sich einschreiben, Unterrichtsgebühren mit iDEAL bezahlen und Reiterkarten kaufen.",
      },
      {
        q: "Wie sieht es mit dem Datenschutz für Pferd- und Eigentümerdaten aus?",
        a: "Jede Person hat eine Rolle (Eigentümer, Reiter, Trainer, Mitarbeiter). Pro Rolle siehst du nur, was du benötigst. Eigentümer sehen nur ihr Pferd, Reiter nur ihre eigenen Stunden.",
      },
      {
        q: "Kann EquiSight mit meiner Buchhaltungssoftware verbunden werden?",
        a: "Ja, Verbindungen mit Exact, Moneybird und e-Boekhouden sind verfügbar. Rechnungen werden dann automatisch in deine Buchhaltung übertragen.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trainer App Pferd: Vergleich & Entscheidungshilfe für Coaches 2026",
      description: "Trainer-Apps für Pferd und Reiter vergleichen: Trainingslog, Video, Ziele, Protokollanalyse und Kundenverwaltung. Finde das richtige Tool für Coaches.",
      keywords: [
        "Trainer App Pferd",
        "Instrukteur App",
        "Pferd Training App",
        "Reiter Coaching App",
        "Trainingstagebuch Pferd",
        "Dressurprotokoll analysieren",
        "Pferdetrainer Software",
      ],
    },
    hero: {
      eyebrow: "Entscheidungshilfe · Trainer-Software",
      breadcrumbLabel: "Trainer App",
      title: "Trainer App Pferd: vollständige Entscheidungshilfe für Instrukteure und Coaches.",
      intro: "Ein Trainer oder Instrukteur jongliert mit Kombinationen, Lektionen, Videos, Zielen und Turnieren. Vergleiche die besten Trainer-Apps für Pferdemenschen und wähle die Plattform, die auch 2026 noch mit deinem Coaching mitwächst.",
      pills: [
        {
          icon: "Target",
          label: "Ziele & Planung",
        },
        {
          icon: "Video",
          label: "Videoanalyse",
        },
        {
          icon: "TrendingUp",
          label: "Fortschritt",
        },
        {
          icon: "Users",
          label: "Kunden/Kombinationen",
        },
      ],
      ctas: [
        {
          label: "Kostenlos als Trainer starten",
          href: "#start",
          primary: true,
        },
        {
          label: "Zur Vergleichstabelle",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Warum WhatsApp-Coaching Trainer ausbremst.",
      lead: "Die meisten Trainer arbeiten mit losen Tools: WhatsApp für Kommunikation, ein Notizbuch für Lektionen, YouTube oder WeTransfer für Videos und Excel für Turnierergebnisse. Bei 5 Reitern funktioniert das. Bei 20 Reitern gehen Informationen verloren, werden Ziele vergessen und verlierst du den Überblick über den individuellen Fortschritt.",
      items: [
        "Wo steht Anouks Ziel für diese Saison?",
        "Welches Video habe ich letzten Monat an Bram geschickt?",
        "Hat Lara die Protokollanalyse ihres letzten Turniers gesehen?",
        "Welche Kombination trainiert wie oft pro Woche?",
        "Hat der Besitzer von Stardust meine Trainingsanweisung gelesen?",
        "Wann habe ich zuletzt Feedback zu schwankender Impulsion gegeben?",
      ],
    },
    what: {
      title: "Was ist eine Trainer-App für Pferd und Reiter?",
      lead: "Eine Trainer-App kombiniert ein Coaching-CRM (Kombinationen, Lektionen, Ziele), ein Trainingslog pro Pferd, Video-Feedback, Turnierplanung und Protokollanalyse. Kein loses WhatsApp/YouTube/Excel mehr, sondern eine Plattform, auf der Trainer und Reiter gemeinsam arbeiten.",
      targetGroupsTitle: "Für welchen Trainertyp ist das gedacht?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dressur-Instrukteur",
          body: "Protokolle scannen, Richterkommentare mit Trainingszielen verknüpfen, Fortschritt sehen.",
        },
        {
          icon: "Activity",
          title: "Springtrainer",
          body: "Parcourplanung, Umlauffeedback, Höhenverwaltung pro Pferd.",
        },
        {
          icon: "Award",
          title: "Eventing-Coach",
          body: "Drei Disziplinen, drei Planungen – alle nebeneinander sichtbar.",
        },
        {
          icon: "TrendingUp",
          title: "Performance-Coach (Sport)",
          body: "EPI-Tracking, Turniere, Ziele – für Leistungssportler und ihre Teams.",
        },
        {
          icon: "Users",
          title: "Reithallen-Instrukteur",
          body: "Gruppenunterricht + Einzelcoaching in einer App.",
        },
        {
          icon: "Heart",
          title: "Freizeitcoach",
          body: "Hippotherapie, Anfänger, Besitzer mit einem Pferd.",
        },
      ],
    },
    criteria: {
      title: "Was muss eine gute Trainer-App erfüllen?",
      lead: "Trainieren ist Menschenarbeit, aber das richtige Tool macht dich 30–50 % effizienter und hilft Reitern, sich auch zwischen den Lektionen zu verbessern.",
      items: [
        {
          icon: "Users",
          title: "Kombinationsverwaltung",
          body: "Pferd + Reiter als eine Einheit, mit Niveau, Zielen, Fortschritt und Historie.",
        },
        {
          icon: "ClipboardList",
          title: "Lektionsnotizen & Ziele",
          body: "Pro Lektion eine Notiz mit Schwerpunkten, verknüpft mit langfristigen Zielen.",
        },
        {
          icon: "Video",
          title: "Video-Feedback",
          body: "Video hochladen, Momente markieren, gesprochenes oder schriftliches Feedback hinzufügen.",
        },
        {
          icon: "Target",
          title: "Turnier- & Protokollanalyse",
          body: "Protokolle scannen (KNHS/FEI), Scores pro Teilaufgabe, Richterkommentare und Trends sehen.",
        },
        {
          icon: "Calendar",
          title: "Planung & Lektionskarten",
          body: "Kalender, Zahlungen, Abonnements und automatische Erinnerungen.",
        },
        {
          icon: "Share2",
          title: "Kommunikation an den Reiter",
          body: "Der Reiter sieht seine eigene Seite mit Lektionen, Videos, Zielen und Feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. andere Trainer-Apps.",
      lead: "Manche Trainer-Tools konzentrieren sich auf WhatsApp-Ersatz, andere auf Protokollanalyse. EquiSight kombiniert beides mit einer echten Pferdeakte – damit der Reiter sich auch zwischen den Lektionen verbessert.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Kostenlos starten",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinationsverwaltung",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Lektionsnotizen & Feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Langfristige Ziele",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Video-Upload + Feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI-Protokoll scannen",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Performance Index)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Turnierkalender",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Reiterportal",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Lektionskarte / Abonnement",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online-Zahlungen",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrierte Pferdeakte",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hufschmied/Tierarzt sichtbar",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Für Instrukteur UND Reiter",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Mehrere Pferde pro Reiter",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Vergleich basierend auf öffentlich verfügbaren Funktionen vom Januar 2026. EquiSight ist einzigartig in der Protokollanalyse + EPI und kombiniert dies mit allgemeinem Pferdmanagement.",
    },
    why: {
      title: "Warum EquiSight ein anderes Trainer-Erlebnis bietet.",
      lead: "Die meisten Trainer-Tools enden dort, wo die Lektion aufhört. EquiSight läuft weiter – in der Pferdeakte, in der Turnieranalyse, in der Zusammenarbeit mit Tierarzt und Besitzer.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokollscan → Trainingsziel",
          body: "Scanne ein KNHS-Protokoll und sieh sofort, welche Teilaufgaben Aufmerksamkeit benötigen. Ziele werden automatisch sichtbar.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach schärft deinen Blick",
          body: "Daten aus mehreren Lektionen, Turnieren und Protokollen zeigen Muster, die du im Kopf nicht behältst.",
        },
        {
          icon: "Share2",
          title: "Integriert mit dem Pferd",
          body: "Der Trainer sieht Impfungen, Hufschmied- und Verletzungshistorie des Pferdes – kein Training während der Erholungsphase planen.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Für Dressur und Springen",
      title: "Was ein Coaching-Dossier in EquiSight enthält.",
      lead: "Pro Kombination erhältst du einen Coaching-Stream, der alles zusammenhält – nie wieder Dinge in WhatsApp verlieren.",
      items: [
        "Lektionsnotizen mit Schwerpunkten pro Einheit",
        "Langfristige Ziele + Meilensteine",
        "Video-Upload mit Timecode-Kommentaren",
        "KNHS/FEI-Protokollscan mit Scores",
        "Richterkommentare mit Training verknüpft",
        "Turnierergebnisse und EPI-Trend",
        "Kundenkontakt und Lektionshistorie",
        "Lektionskarte / Abonnement / Rechnungen",
        "Fortschrittsdiagramm pro Disziplin",
        "Geteilter Zugang mit Pferdebesitzer",
      ],
      ctaLabel: "Trainermodul ansehen",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Von WhatsApp + YouTube zu EquiSight Trainer.",
      lead: "Konkret: So verändert sich dein Coaching-Workflow.",
      rows: [
        {
          before: "WhatsApp mit losen Videolinks",
          after: "Video mit Timecode-Feedback in der Akte",
        },
        {
          before: "Notizbuch pro Reiter",
          after: "Coaching-Log mit Zielen + Historie",
        },
        {
          before: "Excel mit Turnierergebnissen",
          after: "EPI-Diagramm + Protokollanalyse",
        },
        {
          before: "Mündliche Ziele",
          after: "Meilensteine mit Fortschrittsindikator",
        },
        {
          before: "Separates Abrechnungstool",
          after: "Lektionen + iDEAL + Abonnement in der App",
        },
        {
          before: "E-Mail an Besitzer über Fortschritt",
          after: "Besitzer verfolgt alles in eigener Ansicht",
        },
      ],
    },
    helper: {
      title: "Welche Trainer-App passt zu dir?",
      lead: "5 Fragen, um zu sehen, ob ein spezialisiertes Coaching-Tool einen Mehrwert für deine Praxis hat.",
      questions: [
        {
          id: "clients",
          q: "Wie viele aktive Kombinationen coachst du?",
          options: [
            {
              label: "Weniger als 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Mehr als 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Was ist deine Hauptdisziplin?",
          options: [
            {
              label: "Dressur",
              score: 3,
            },
            {
              label: "Springen",
              score: 2,
            },
            {
              label: "Freizeit / diverses",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Nutzt du Video beim Coaching?",
          options: [
            {
              label: "Selten",
              score: 0,
            },
            {
              label: "Manchmal (manuell)",
              score: 2,
            },
            {
              label: "Oft – strukturiert",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Coachst du Turniereiter?",
          options: [
            {
              label: "Nein, Freizeit",
              score: 0,
            },
            {
              label: "Manchmal Turniere",
              score: 2,
            },
            {
              label: "Viel – Startkarten im Mittelpunkt",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Möchtest du dein Coaching messen?",
          options: [
            {
              label: "Nein, Intuition reicht",
              score: 0,
            },
            {
              label: "Schon, aber keine Zeit",
              score: 2,
            },
            {
              label: "Ja – datengesteuertes Coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ein einfaches Tool oder sogar WhatsApp reicht – vorerst.",
          body: "Für weniger als 5 Reiter ohne viel Video oder Turniere ist eine Coaching-App übertrieben. EquiSight startet kostenlos, also kannst du es ausprobieren, wenn deine Praxis wächst.",
          cta: "Kostenlos starten",
        },
        mid: {
          title: "EquiSight Trainer macht dich strukturell effizienter.",
          body: "Mit 5–15 Kombinationen verlierst du monatlich Stunden an WhatsApp und losen Videos. EquiSight bündelt alles, scannt Protokolle automatisch und sorgt dafür, dass Reiter ihr Feedback jederzeit abrufen können.",
          cta: "Trainermodul ausprobieren",
        },
        high: {
          title: "EquiSight ist für deine Coaching-Größenordnung gebaut.",
          body: "Viele Reiter, Video, Turniere und datengesteuertes Coaching: genau hier hebt sich EquiSight ab. EPI + Protokollscan + Pferdeakte verschaffen dir einen Vorsprung, den Mitbewerber nicht haben.",
          cta: "Demo für deine Coaching-Praxis planen",
        },
      },
    },
    faqTitle: "Häufig gestellte Fragen zu Trainer-Apps",
    faq: [
      {
        q: "Was ist die beste Trainer-App für Pferd und Reiter?",
        a: "Für reine Kommunikation reichen viele Tools (sogar WhatsApp). Für Ziele, Videoanalyse, Protokollscan, Turniertracking und Kundenverwaltung in einem Tool ist EquiSight die vollständigste Lösung – vor allem weil es auch das Pferd selbst verwaltet, nicht nur die Kombination.",
      },
      {
        q: "Kann EquiSight Turnierprotokolle automatisch lesen?",
        a: "Ja. Lade ein KNHS- oder FEI-Protokoll hoch und EquiSight extrahiert die Scores pro Teilaufgabe, Richterkommentare und verknüpft diese mit der Kombination. Trends siehst du über mehrere Turniere hinweg.",
      },
      {
        q: "Was ist der EPI (Equestrian Performance Index)?",
        a: "EPI ist ein EquiSight-Score, der mehrere Turnierergebnisse in einen vergleichbaren Leistungsindex umrechnet. Dadurch siehst du echten Fortschritt über verschiedene Klassen und Richter hinweg.",
      },
      {
        q: "Können Reiter meine Lektionen selbst buchen und bezahlen?",
        a: "Ja. Reiter loggen sich ein, sehen verfügbare Lektionszeiten, kaufen Lektionskarten und bezahlen per iDEAL. Du entscheidest, was du anbieten möchtest.",
      },
      {
        q: "Funktioniert es auch für einen Instrukteur, der rund um die Reitanlage arbeitet?",
        a: "Ja. Du kannst als freiberuflicher Trainer mit eigenen Kunden arbeiten, ohne ein Reithallenaccount verknüpfen zu müssen. Kunden zahlen direkt an dich.",
      },
      {
        q: "Kann ich bestehende Videos und Notizen migrieren?",
        a: "Videos können pro Kombination hochgeladen oder über ein Batch-Upload-Tool importiert werden. Notizen werden per CSV importiert. Wir helfen aktiven Trainern mit einer einmaligen Migration.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Ratgeber & Entscheidungshilfen für Pferdemanagement-Software | EquiSight",
      description: "Alle EquiSight-Ratgeber auf einen Blick: Pferdemanagement, Zucht, Reitanlage und Trainer-Software-Vergleiche plus Entscheidungshilfen für 2026.",
      keywords: [
        "Pferdesoftware Ratgeber",
        "Pferdemanagement Entscheidungshilfe",
        "Zuchtsoftware vergleichen",
        "Reitanlage Software Ratgeber",
        "Trainer-App Vergleich",
      ],
    },
    hub: {
      eyebrow: "Hub · Ratgeber",
      breadcrumbLabel: "Ratgeber",
      title: "Vier vollständige Ratgeber zur Wahl der richtigen Pferdesoftware.",
      intro: "Für jede Zielgruppe eine ausführliche Entscheidungshilfe: Vergleichstabellen, Kriterien, Beispiele und interaktives Quiz. Klicken Sie zum passenden Ratgeber für Ihre Situation oder erkunden Sie zunächst die vertiefenden Artikel unter jedem Cluster.",
      stats: {
        guides: "4 Entscheidungshilfen",
        articles: "15 vertiefende Artikel",
        fair: "Fairer Vergleich",
      },
      readMoreCta: "Den vollständigen Ratgeber lesen",
      relatedHeading: "Vertiefende Artikel",
      articlesCountSingular: "{{count}} vertiefender Artikel",
      articlesCountPlural: "{{count}} vertiefende Artikel",
      articlesCountAria: "Anzahl Cluster-Artikel",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Pferdemanagement-App Entscheidungshilfe",
        blurb: "Vergleichen Sie die bekanntesten Pferdemanagement-Apps und finden Sie heraus, welche zu Eigentümer, Stall oder Zucht passt. Inklusive fairem Vergleichstabelle und 5-Fragen-Entscheidungshilfe.",
        audience: "Für Pferdebesitzer, Stallbetreiber und alle Pferdemenschen, die den Überblick suchen.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Zuchtsoftware Vergleich",
        blurb: "Vom Stutenzyklus bis zur Fohlenenentwicklung: Prüfen Sie, welche Zuchtsoftware wirklich zu Ihrer Anzahl Stuten, Zuchtmethode und Zuchtbuchanforderungen passt.",
        audience: "Für (Hobby-)Züchter, Gestüte und Hengsthalter.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Reitanlage-Software Entscheidungshilfe",
        blurb: "Unterrichtsplanung, Reiterverivaltung, Eigentümerportal und Rechnungsstellung — in einem Tool. Vergleichen Sie die Optionen für Reitanlagen und Pensionsställe im Jahr 2026.",
        audience: "Für Reitanlagen, Pensionsställe und Reitbetriebe.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trainer-App Entscheidungshilfe",
        blurb: "Coaching-CRM, Video-Feedback, KNHS-Protokoll scannen und Ziele pro Kombination. Welche Trainer-App passt zu Ihrer Coaching-Praxis?",
        audience: "Für Reitlehrer, Trainer und Coaches.",
      },
    ],
    closing: {
      eyebrow: "Warum diese Ratgeber",
      title: "Ehrlich vergleichen, nicht nur Preise.",
      body1: "Viele \"Vergleichsseiten\" sind verdeckte Werbung. Unsere Ratgeber stellen Funktionen, Zielgruppe und Mitbewerber nebeneinander, so wie es eine unabhängige Wissensquelle tun würde. EquiSight kommt dabei natürlich als vollständige Lösung zum Vorschein, aber Sie lesen auch ehrlich, wo andere Apps stärker sind.",
      body2: "Die vertiefenden Artikel unter jedem Ratgeber beantworten die konkreten Fragen, die sich aus der Entscheidung ergeben: \"Wann erste Ultraschalluntersuchung nach der Besamung\", \"Wie automatisiere ich die Rechnungsstellung in der Reitanlage\", \"Wie analysiere ich ein Wettkampfprotokoll\". Kein Marketing-Fluff, sondern echte Praxis.",
    },
    hubName: "EquiSight Ratgeber",
  },
  ui: {
    sectionEyebrows: {
      pains: "Warum das schmerzt",
      basics: "Grundlagen",
      criteria: "Was macht es gut?",
      comparison: "Ehrlicher Vergleich",
      why: "Der Unterschied",
      beforeAfter: "Von Fragmentierung zu Übersicht",
      helper: "5 Fragen",
    },
    table: {
      feature: "Funktion",
      today: "Heute",
      withEquisight: "Mit EquiSight",
    },
    helper: {
      questionLabel: "Frage {{current}} von {{total}}",
      answerPrompt: "Beantworte die {{count}} verbleibende Frage, um eine Empfehlung zu sehen.",
      answerPromptPlural: "Beantworte die {{count}} verbleibenden Fragen, um eine Empfehlung zu sehen.",
      resultEyebrow: "Dein Ergebnis",
    },
    targetGroupsFallback: "Für wen ist das gedacht?",
    faqTitleFallback: "Häufig gestellte Fragen",
  },
};

export default CORNERSTONES;
